
import { Component, Vue } from 'vue-property-decorator';

import { Client, IClientCreateModel, ClientCreateModel } from '@/services/api.service';
@Component
export default class ClientCreate extends Vue {


  // Client properties
  public name: string = '';
  public addressLine1: string = '';
  public addressLine2: string = '';
  public addressLine3: string = '';
  public locality: string = '';
  public region: string = '';
  public postcode: string = '';

  // Contact properties
  public contactName: string = '';
  public phone: string = '';
  public mobile: string = '';
  public email: string = '';
  public position: string = '';

  private createClient() {
    console.log('creating client');
    const me = this;
    const createModel: IClientCreateModel = {
      name: this.name,
      addressLine1: this.addressLine1,
      addressLine2: this.addressLine2,
      addressLine3: this.addressLine3,
      locality: this.locality,
      region: this.region,
      postcode: this.postcode,
      contactName: this.contactName,
      phone: this.phone,
      mobile: this.mobile,
      email: this.email,
      position: this.position};

    const clientService: Client = new Client(process.env.VUE_APP_API_URL, this.$http);
    // @ts-ignore
    this.$Progress.start();
    clientService.createClient(new ClientCreateModel(createModel)).then((data) => {
      // Route to the edit client screen?
      // @ts-ignore
      this.$Progress.finish();
      // @ts-ignore
      this.$awn.success('Client ' + this.name + ' created successfully');
      // For the moment, nav to the client screen
      this.$router.push({ path: '/clients' });
    });
  }

  private cancelCreateClient() {
    this.$router.push({ path: '/clients' });
  }
}
